import { Component } from "react";
import Form from "react-validation/build/form";

import {
  renderTextBox,
  renderMultiTextBox,
  renderAdditionalComments,
  renderFile,
  renderAddDeleteButton,
  renderYesNo,
} from "./RenderUtils";

export class WcWaiverOfSubrogationRequest extends Component {
  render() {
    var request = this.props.data;
    var updateRequest = this.props.updateRequest;

    return (
      <Form ref={this.props.formRef}>
        <div>
          {renderAddDeleteButton(
            "Add/Delete Waiver of Subrogation",
            request,
            updateRequest
          )}
          {renderTextBox(
            "completeName",
            "Complete Name of waiver of subrogation holder",
            request,
            updateRequest
          )}
          {renderMultiTextBox(
            "completeAddress",
            "Complete Address of waiver of subrogation holder",
            request,
            updateRequest
          )}
          {renderTextBox(
            "relationshipOfTheThirdPartyToTheInsured",
            "What is the insured’s relationship to the waiver of subrogation holder?",
            request,
            updateRequest
          )}
          {renderYesNo(
            "wosHolderListedAsAdditionalInsured",
            "Does the waiver of subrogation holder need to be listed as an Additional Insured?",
            request,
            updateRequest
          )}
          {renderAdditionalComments(updateRequest)}
          {renderFile(request, updateRequest)}
        </div>
      </Form>
    );
  }
}
